const RETURN_PATH_KEY = "matematron.seoLearning.returnPath.v1";
const MAX_RETURN_PATH_AGE_MS = 24 * 60 * 60 * 1000;

function sanitizeLearningPath(value) {
  const path = String(value || "");
  if (!path.startsWith("/") || path.startsWith("//")) return "";
  if (/^\/(login|logowanie|register|rejestracja|verify-email|aktywuj-dostep|admin)(\/|\?|#|$)/.test(path)) {
    return "";
  }
  return path.slice(0, 2000);
}

function getLocalDayEnd(now = new Date()) {
  const end = new Date(now);
  end.setHours(24, 0, 0, 0);
  return end.getTime();
}

function resolveAuthenticatedLearningPath(path) {
  const stored = sanitizeLearningPath(path);
  if (!stored) return "";
  try {
    const url = new URL(stored, window.location.origin);
    if (url.pathname.startsWith("/demo-temat/")) {
      url.pathname = url.pathname.replace("/demo-temat/", "/");
    } else if (url.pathname.startsWith("/demo/matura/sciezka")) {
      url.pathname = url.pathname.replace("/demo/matura/sciezka", "/matura/sciezka");
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "";
  }
}

function readReturnEntry() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(RETURN_PATH_KEY);
    if (!raw) return null;
    let parsed = null;
    try {
      parsed = JSON.parse(raw);
    } catch {
      // Wpisy ze starszej wersji zachowujemy tylko w bieżącej sesji migracji.
      parsed = { path: raw, savedAt: Date.now(), expiresAt: getLocalDayEnd() };
    }
    const path = sanitizeLearningPath(parsed?.path);
    const savedAt = Number(parsed?.savedAt || 0);
    const expiresAt = Number(parsed?.expiresAt || 0);
    const now = Date.now();
    if (!path || !expiresAt || expiresAt <= now || (savedAt && now - savedAt > MAX_RETURN_PATH_AGE_MS)) {
      window.localStorage.removeItem(RETURN_PATH_KEY);
      return null;
    }
    return { path, savedAt, expiresAt };
  } catch {
    return null;
  }
}

export function rememberSeoLearningReturnPath(explicitPath = "") {
  if (typeof window === "undefined") return "";
  const currentPath = explicitPath || `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const path = sanitizeLearningPath(currentPath);
  if (!path) return "";
  try {
    const now = Date.now();
    window.localStorage.setItem(RETURN_PATH_KEY, JSON.stringify({
      path,
      savedAt: now,
      expiresAt: Math.min(now + MAX_RETURN_PATH_AGE_MS, getLocalDayEnd(new Date(now))),
    }));
  } catch {}
  return path;
}

export function consumeSeoLearningReturnPath() {
  if (typeof window === "undefined") return "";
  try {
    const stored = readReturnEntry()?.path || "";
    window.localStorage.removeItem(RETURN_PATH_KEY);
    return resolveAuthenticatedLearningPath(stored);
  } catch {
    return "";
  }
}

export function peekSeoLearningReturnPath() {
  return resolveAuthenticatedLearningPath(readReturnEntry()?.path || "");
}

export function clearSeoLearningReturnPath() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(RETURN_PATH_KEY);
  } catch {}
}

export const seoLearningReturnPathStorageKey = RETURN_PATH_KEY;
